import { isOnlineClubPass } from "./passHelpers";

/**
 * Active pass = paid, active/exhausted/paused, not expired.
 */
function isActivePass(pass, now) {
  if (pass.paid === false) return false;
  if (!["active", "exhausted", "paused"].includes(pass.status)) return false;
  return new Date(pass.expiresAt) > now;
}

/** User has at least one active online club pass (PassType.onlineOnly), or role studio. */
export function hasActiveOnlineClubPass(user) {
  if (user?.role === "studio" || user?.role === "admin") return true;
  if (!user?.passes?.length) return false;
  const now = new Date();
  return user.passes.some((pass) => isOnlineClubPass(pass) && isActivePass(pass, now));
}

/** User has at least one active studio/non–online-club pass. */
export function hasActiveStudioPass(user) {
  if (user?.role === "studio" || user?.role === "admin") return true;
  if (!user?.passes?.length) return false;
  const now = new Date();
  return user.passes.some((pass) => !isOnlineClubPass(pass) && isActivePass(pass, now));
}

/** User has at least one active multi-class (or unlimited) pass — eligible for Regular Days auto-booking. */
export function hasMultiClassPass(user) {
  if (user?.role === "onlineClub" || user?.role === "basic") return false;
  if (!user?.passes?.length) return false;
  const now = new Date();
  return user.passes.some(
    (pass) => isActivePass(pass, now) && (pass.classesIncluded == null || pass.classesIncluded > 1)
  );
}
